



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgingTransDocument } from './../entities/agingtransdocument.entity';
import { TransDocumentListParams } from './../params/transdocumentlist.param';
@Injectable()
export class AgingTransDocumentEndpoint extends BaseEndpointCRUD<AgingTransDocument>
{
    constructor(api: APIGatewayService) {super("AgingTransDocument", api);}
	

    public  GetListByParams(Params: TransDocumentListParams, options: DataLoadOptions) : Observable<BaseEntitiesResponse<AgingTransDocument>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'GetListByParams', Params,  options?.GetLoadOptions() );
    }
}

